import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  pt: string = 'pt-0';
  pb: string = 'pb-100'; 
  section: string = 'contact'; 

  constructor() { }

  ngOnInit(): void {
  }

}
